<template>
  <v-card flat>
    <v-card-title class="white">
      <v-btn icon @click="$router.back()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-spacer/>
      <v-btn :disabled="!canSave" :loading="loading" class="btn-accept" depressed rounded @click="saveEdited">
        <v-icon left>fa-save</v-icon>
        <span class="letter-spacing-none">ذخیره</span>
      </v-btn>
    </v-card-title>

    <contacts-edit-fields v-model="info" :avatarFile.sync="avatarFile" :can-more.sync="canSave"/>
  </v-card>
</template>

<script>
import ContactsEditFields from "@/view/content/contacts/contactsEditFields.vue";
import {mapState} from "vuex"

export default {
  name: "newContact",

  components: {ContactsEditFields},

  props: {
    phoneTag: Object
  },

  data: () => ({
    avatarFile: null,
    canSave: false,
    info: {
      phone: '',
      phone_tags: [],
      avatar: null,
      preName: '',
      name: '',
      middleName: '',
      lastName: '',
      postName: '',
      alias: '',
      companyName: '',
      jobTitle: '',
      birthday: '',
      description: '',
      province_id: '',
      city_id: '',
      email: [],
      address: [],
      website: [],
      custom: [],
      date_times: []
    },
    loading: false,
  }),

  computed: {
    ...mapState('locals', ['selectedPhonebook'])
  },

  methods: {
    saveEdited() {
      this.loading = true
      let formData = new FormData()

      let obj = this.info

      if (!obj.phone_tags || !obj.phone_tags.length)
        obj.phone_tags = [this.selectedPhonebook]

      let arr = Object.entries(obj)

      console.log('arr: ', arr)

      arr.forEach(val => {
        if (val[0] === 'phone_tags')
          formData.append(val[0], Array.from(new Set(val[1])));
        else if (val[0] === 'avatar')
          formData.append(val[0], this.avatarFile ?? '');
        else if (val[1] instanceof Array)
          formData.append(val[0], JSON.stringify(val[1]));
        else
          formData.append(val[0], val[1] || '');
      })

      this.requestApiPostPayamak('contact/store', formData)
        .then(({data}) => this.goto('phonebook'))
        .catch(({response}) => console.log('error in save contact: ', response))
        .finally(() => this.loading = false)
    }
  },

  beforeDestroy() {
    this.$emit('fetch')
  }
}
</script>